var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#295C8F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.456,29.422H18.638l6.306,6.306c2.167,2.167,2.166,5.682-0.004,7.847l0,0 c-2.166,2.162-5.675,2.161-7.84-0.004L1.731,28.2c-2.306-2.306-2.308-6.045-0.003-8.353l15.408-15.43 c2.144-2.147,5.621-2.15,7.768-0.006l0,0c2.251,2.246,2.13,5.929-0.263,8.023l-6.742,5.9h24.558c3.062,0,5.544,2.482,5.544,5.544v0 C48,26.939,45.518,29.422,42.456,29.422z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.fd2b434773a80e7d2c8f5073ab82e97d.svg";
export { ForwardRef as ReactComponent };